"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.update = void 0;
var websockets_sidecar_1 = require("@engine/websockets-sidecar");
var common_sidecar_1 = require("@main/common-sidecar");
var uiFps_sidecar_1 = require("@ui/uiFps-sidecar");
var clickEater_sidecar_1 = require("@uiParts/clickEater-sidecar");
var stevieTexts2_sidecar_1 = require("@uiParts/stevieTexts2-sidecar");
var voyageCamera_sidecar_1 = require("@voyage/camera/voyageCamera-sidecar");
var crokinoleBackground_sidecar_1 = require("@crokinole/background/crokinoleBackground-sidecar");
var crokinoleGamepadCursors_sidecar_1 = require("@crokinole/cursors/crokinoleGamepadCursors-sidecar");
var crokinoleMultiplayerCursors_sidecar_1 = require("@crokinole/cursors/crokinoleMultiplayerCursors-sidecar");
var crokinoleGameManager_sidecar_1 = require("@crokinole/main/crokinoleGameManager-sidecar");
var crokinoleSimulationManager_sidecar_1 = require("@crokinole/main/crokinoleSimulationManager-sidecar");
var crokinoleMenuCreator_sidecar_1 = require("@crokinole/to-engine/crokinoleMenuCreator-sidecar");
var crokinoleUi_clickToFocus_sidecar_1 = require("@crokinole/ui/crokinoleUi_clickToFocus-sidecar");
var crokinoleUi_multiplayerDebug_sidecar_1 = require("@crokinole/ui/crokinoleUi_multiplayerDebug-sidecar");
var crokinoleUi_multiplayerStatus_sidecar_1 = require("@crokinole/ui/crokinoleUi_multiplayerStatus-sidecar");
var diveColors_1 = require("@dive/colors/diveColors");
var diveDebug_sidecar_1 = require("@dive/debug/diveDebug-sidecar");
var diveFont_sidecar_1 = require("@dive/fonts/diveFont-sidecar");
var rogueGlyphs_sidecar_1 = require("@dive/fonts/rogueGlyphs-sidecar");
var imageRecycler_sidecar_1 = require("@dive/to-engine/imageRecycler-sidecar");
var diveUi_messages_sidecar_1 = require("@dive/ui/diveUi_messages-sidecar");
var crokinoleBoard_sidecar_1 = require("proto/crokinole/board/crokinoleBoard-sidecar");
var crokinoleGamepad_sidecar_1 = require("proto/crokinole/input/crokinoleGamepad-sidecar");
var physics_rapier_loader_sidecar_1 = require("proto/crokinole/physics/physics_rapier_loader-sidecar");
var crokinoleUi_turnInfo_sidecar_1 = require("proto/crokinole/ui/crokinoleUi_turnInfo-sidecar");
var crokinoleUi_menu_main_sidecar_1 = require("../ui-menus/crokinoleUi_menu_main-sidecar");
var update = function (time, delta) {
    // let ctx = goatScene.getContext()
    common_sidecar_1.common.setUpdateDelta(delta / 1000);
    var curSpeedScale = 1;
    common_sidecar_1.common.setUpdateDeltaScaled((delta / 1000) * curSpeedScale);
    if (common_sidecar_1.common.updateFocus()) {
        // Focus changed
        clickEater_sidecar_1.clickEater.tempEat();
    }
    // Temp overrides
    // voyageMenuMain.setOpen(false)
    crokinoleSimulationManager_sidecar_1.crokinoleSimulationManager.update();
    imageRecycler_sidecar_1.imageRecycler.resetAll();
    // voyageBackground.update()
    // voyageGameStatus.update()
    crokinoleGameManager_sidecar_1.crokinoleGameManager.update();
    uiFps_sidecar_1.uiFps.update(function (fps) {
        var gb = voyageCamera_sidecar_1.voyageCamera.getGameBounds();
        diveFont_sidecar_1.diveFont.writeAbsolute(gb.width - 30, gb.height - 8, '' + fps, 0.5, diveColors_1.diveColors.pureWhite);
    });
    // buttons2.updateAll()
    // voyageUiMessage.update()
    // voyageUiMultiListGames.update()
    crokinoleUi_menu_main_sidecar_1.crokinoleUi_menu_main.update();
    // voyageUiSubsystem.update()
    // voyageUiNav.update()
    // voyageStarmaps.updateAll()
    // diveSlashEffect.updateAll()
    // voyageBodies.updateAll()
    // voyageIndicators.updateAll()
    // New ui stuff
    // diveUi_abilitiesBar.update()
    // voyagePicker.update()
    // voyageTilemapEditor.update()
    // Dive stuff, new
    // diveTilemap_renderer.render()
    // if (diveDebug.debug_viewGenHyperspace) {
    //   if (diveTilemapHyperspace.exists()) {
    //     diveTilemap_renderer.render_generic(diveTilemapHyperspace.get(), -20, -20)
    //   }
    // }
    // diveGeneratorManager.update()
    // diveObjects.updateAll()
    // diveCrew.updateAll()
    // diveBullets.updateAll()
    // voyageToolBodyAlign.update()
    voyageCamera_sidecar_1.voyageCamera.update();
    // voyageCameraStarmap.update()
    // voyageBullets.updateAll()
    // voyageCarryable.updateAll()
    // voyageJettisons.updateAll()
    crokinoleMultiplayerCursors_sidecar_1.crokinoleMultiplayerCursors.updateAll();
    // diveMultiplayerCursors.updateAll()
    //voyageMovementIndicators.updateAll()
    // diveMovementIndicators.updateAll()
    // voyageUiInfoBar.update()
    // voyageUiTutorial.update()
    // voyageParticles.updateAll()
    // diveParticles.updateAll()
    // voyageFloatingText.updateAll()
    // voyageUiPaused.update()
    // voyageUiBuyStuff.update()
    // voyageUiLoadShip.update()
    // voyageUiEditor.update()
    // dive_pathMovementIndicators.updateAll()
    // voyageUiGame.update()
    // voyageUiGameMultiplayer.update()
    crokinoleUi_multiplayerStatus_sidecar_1.crokinoleUi_multiplayerStatus.render();
    crokinoleUi_multiplayerDebug_sidecar_1.crokinoleUi_multiplayerDebug.update();
    stevieTexts2_sidecar_1.stevieTexts2.updateAll();
    clickEater_sidecar_1.clickEater.updateAll();
    diveUi_messages_sidecar_1.diveUi_messages.drawAll();
    // diveUi_messagesRecent.open()
    // diveUi_messagesRecent.drawAll()
    crokinoleGamepadCursors_sidecar_1.crokinoleGamepadCursors.updateAll();
    // voyageShipSaver.trySave()
    websockets_sidecar_1.websockets.update();
    if (diveDebug_sidecar_1.diveDebug.debug_runSpyders) {
        // diveSpyderTilemap.checkObjectsAndCrewLinks()
    }
    crokinoleBackground_sidecar_1.crokinoleBackground.update();
    if (physics_rapier_loader_sidecar_1.physics_rapier_loader.isLoaded()) {
        crokinoleGamepad_sidecar_1.crokinoleGamepad.updateGamepad();
        crokinoleBoard_sidecar_1.crokinoleBoard.update();
        physics_rapier_loader_sidecar_1.physics_rapier_loader.updatePhysics_localhost(common_sidecar_1.common.getUpdateDelta());
        crokinoleUi_turnInfo_sidecar_1.crokinoleUi_turnInfo.open();
        crokinoleUi_turnInfo_sidecar_1.crokinoleUi_turnInfo.drawAll();
    }
    crokinoleMenuCreator_sidecar_1.crokinoleMenuCreator.update();
    crokinoleMenuCreator_sidecar_1.crokinoleMenuCreator.render();
    crokinoleMenuCreator_sidecar_1.crokinoleMenuCreator.clear();
    // if (crokinoleDefs.proto_showGeoscape) {
    //   geoscapeDemo.run()
    // }
    // if (crokinoleDefs.proto_showBattlescape) {
    //   battlescapeDemo.run()
    // }
    rogueGlyphs_sidecar_1.rogueGlyphs.drawAll();
    crokinoleUi_clickToFocus_sidecar_1.crokinoleUi_clickToFocus.update();
};
exports.update = update;
